import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CompletedCampaign } from 'src/app/core-module/models/Campaigns/completed-campaign';

@Component({
  selector: 'app-campaign-detail',
  templateUrl: './campaign-detail.component.html',
  styleUrl: './campaign-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CampaignDetailComponent {
  @Input() Campaign: CompletedCampaign
  @Output() GoToResult: EventEmitter<number> = new EventEmitter<number>()

  public strokeOffset: number = 0;
  public progress: number = 0;

  constructor() { 
   

  }
  calcStrokeOffset(score: number, maxScore: number) {
    const r = 40;
    const c = 2 * Math.PI * r;
    return c - (c * this.calcProgress(score, maxScore)) / 100;
  }
  calcProgress(score: number, maxScore: number) {
    if (maxScore > 0) {
      return Math.round((score / maxScore) * 100);
    }
    return 0;
  }
  selectAudit(auditResultID: number) {
    this.GoToResult.emit(auditResultID);
  }

}
